export default __webpack_public_path__ + "static/media/C_sound.11a78852.mp3";